export const CLASS_NAMES = {
  container: 'flex w-full flex-col',
};

export const ITEM_CLASS_NAMES = {
  container:
    'flex flex-row w-full border border-neutral-200 border-b-0 last:border-b first:rounded-t-lg last:rounded-b-lg py-4 px-3',
  title: 'w-full text-style-g text-neutral-700 ml-2',
  icon: 'flex-none mt-1 icon-stroke-md',
};

export const ITEM_PROPS = {
  title: {
    className: ITEM_CLASS_NAMES.title,
    skeletonProps: {
      count: 2,
    },
  },
  icon: {
    size: 16,
    stroke: 'purple-200',
    className: ITEM_CLASS_NAMES.icon,
  },
};
